import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { replace } from 'react-router-redux';
import {
  Button,
  Header,
  Icon,
  Modal,
} from 'semantic-ui-react';

class NotFound extends Component {
  componentWillMount() {
    document.getElementById('preloader-container').classList.remove('app-loading');
  }
  handleAction = (e) => {
    e.preventDefault();
    const { store } = this.context;
    store.dispatch(replace('/'));
  }
  render() {
    return (
      <Modal
        open
        basic
        size="small"
      >
        <Header icon="warning sign" content="Not Found" />
        <Modal.Content>
          <h3>Oops! The page you requested was not found!</h3>
        </Modal.Content>
        <Modal.Actions>
          <Button color="green" onClick={this.handleAction} inverted>
            <Icon name="home" /> Return home safely
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

NotFound.contextTypes = {
  store: PropTypes.object,
};

export default NotFound;



// WEBPACK FOOTER //
// ./src/containers/NotFound.jsx